// Shared applicant shift-interest / availability matching helpers - used by the Applicants
// list (compact badges/filters) and the Applicant Detail page (full matching summary).
// IMPORTANT: this is a "potential match" signal only, never a guarantee of the 40% qualifying
// shift premium - that only applies after hire, once assigned to an approved shift template,
// and only for a fully completed shift (see payroll_service._compute_shift_qualifying_minutes).

export function getShiftInterestTag(applicant) {
  const interests = applicant.shift_interests || [];
  const hasOpening = interests.includes("OPENING");
  const hasClosing = interests.includes("CLOSING");
  if (hasOpening && hasClosing) return { key: "BOTH", label: "Opening + Closing" };
  if (hasOpening) return { key: "OPENING", label: "Opening" };
  if (hasClosing) return { key: "CLOSING", label: "Closing" };
  if (interests.includes("FLEXIBLE")) return { key: "FLEXIBLE", label: "Flexible" };
  return null;
}

export function needsAvailabilityReview(applicant) {
  return !!applicant.availability_review_required;
}

// Real booking-engine status for the Applicants List "Interview" column - replaces the legacy
// status-derived tag that used to live here, which could go stale (e.g. still say "No
// Interview Selected" for a CONTACT_ME applicant who has an active PENDING_CONFIRMATION
// booking). Backed by `interview_booking_status`/`interview_booking_mode`, attached server-side
// in GET /recruitment/applicants (see recruitment_routes.py::list_applicants).
const BOOKING_STATUS_TAGS = {
  CONFIRMED: { key: "CONFIRMED", label: "Confirmed", tone: "emerald" },
  RESCHEDULE_REQUESTED: { key: "RESCHEDULE_REQUESTED", label: "Reschedule Requested", tone: "amber" },
  COMPLETED: { key: "COMPLETED", label: "Completed", tone: "emerald" },
  CANCELLED_BY_APPLICANT: { key: "CANCELLED", label: "Cancelled", tone: "gray" },
  CANCELLED_BY_MANAGEMENT: { key: "CANCELLED", label: "Cancelled", tone: "gray" },
  RESCHEDULED: { key: "CANCELLED", label: "Cancelled", tone: "gray" },
  NO_SHOW: { key: "NO_SHOW", label: "No-Show", tone: "red" },
  EXPIRED: { key: "CANCELLED", label: "Cancelled", tone: "gray" },
};

export function getRealInterviewStatusTag(applicant) {
  const status = applicant.interview_booking_status;
  if (!status) return { key: "NONE", label: "No Interview", tone: "gray" };
  if (status === "HELD") return { key: "REQUESTED", label: "Requested", tone: "amber" };
  if (status === "PENDING_CONFIRMATION") {
    return applicant.interview_booking_mode === "CONTACT_ME"
      ? { key: "REQUESTED", label: "Requested", tone: "amber" }
      : { key: "PENDING_CONFIRMATION", label: "Pending Confirmation", tone: "amber" };
  }
  return BOOKING_STATUS_TAGS[status] || { key: "NONE", label: "No Interview", tone: "gray" };
}
